import { useMemo } from 'react'
import { LayoutModeContext, useComputedLayoutMode } from '@/hooks/useLayoutMode'

/**
 * Single matchMedia subscription for the whole app. Must be mounted inside
 * <ThemeProvider> so the breakpoint values come from the MUI theme.
 */
export function LayoutModeProvider({ children }: { children: React.ReactNode }) {
  const { mode, isBelowMd } = useComputedLayoutMode()
  const value = useMemo(() => ({ mode, isBelowMd }), [mode, isBelowMd])

  return <LayoutModeContext.Provider value={value}>{children}</LayoutModeContext.Provider>
}
